import * as bundle from 'bundle';
import config from 'config';
import core from 'core';
import i18n from 'i18n';
import launcher from 'modules/launcher/launcher';
import BaseView from 'common/base.view';
import 'util/device.util';
import 'modules/api/api';
import 'util/replacer.util';
import replacer from 'util/replacer.util';
import MenuView from 'modules/menu/menu.view';

import 'managers/animation.manager.instance';
// imports are needed for corejs useBuiltIns: 'entry' option
// 'entry' option slightly reduces the bundle size
import 'regenerator-runtime/runtime';
import 'core-js/stable';

const dispatcher = bundle.dispatcher;

replacer.init();

/**
 * Register Backbone portlets in React here, so that licensee override can work.
 */
bundle.registerPortlets({
    'portlets_bingo_scheduler_bingo_scheduler_model': async () => import(/* webpackChunkName: "bingo-scheduler-bb" */ 'portlets/bingo-scheduler/bingo-scheduler.model'),
    'portlets_cashier_iframe_cashier_iframe_model': async () => import(/* webpackChunkName: "cashier-iframe-bb" */ 'portlets/cashier-iframe/cashieriframe.model'),
    'portlets_cashier_cashier_model': async () => import(/* webpackChunkName: "cashier-bb" */ 'portlets/cashier/cashier.model'),
    'portlets_registration_registration_model': async () => import(/* webpackChunkName: "registration-bb" */ 'portlets/registration/registration.model'),
    'modules_menu_menu_view': MenuView,
    'common_base_view':  BaseView
});

/**
 * Propagate configuration from React to Backbone.
 */
dispatcher.listen('app:config', (app) => {
    config.load(app);
});

/**
 * Propagate translations from React to Backbone.
 */
dispatcher.listen('i18n:system:translations', (translations) => {
    i18n.setSystemTranslations(translations);
    core.trigger('app:translationsLoaded');
});

dispatcher.listen('i18n:page:translations', (translations) => {
    i18n.setPageTranslations(translations);
    core.trigger('app:translationsLoaded');
});

dispatcher.listen('i18n:pageInPopup:translations', (translations) => {
    i18n.setPageInPopupTranslations(translations);
    core.trigger('app:translationsLoaded');
});

/**
 * Connect with launcher
 */
dispatcher.listen('game:launch', function(data) {
    launcher.launchGame(data.code, data.mode, data.queryString, {
        categoryName: data.categoryName,
        categoryPosition: data.categoryPosition,
        container: data.container,
        gameFeed: data.gameFeed,
        gameName: data.gameName,
        gamePositionInCategory: data.gamePositionInCategory,
        onGameLaunched: data.onGameLaunched,
        tidPgg: data.tidPgg,
        pggCategoryName: data.pggCategoryName
    });
});

/**
 * Add login logout classes
 */
dispatcher.listen('auth:login', () => {
    document.querySelector('#application').classList.add('logged');
    document.querySelector('#application').classList.remove('loged-out');
});

dispatcher.listen('auth:logout', () => {
    document.querySelector('#application').classList.remove('logged');
    document.querySelector('#application').classList.add('loged-out');
});

/**
 * menu Items from react.
 */
 dispatcher.listen('menu:items', (menuItems) => {
    config.load({ menuItems: menuItems });
});

/**
 * games data from react.
 */
 dispatcher.listen('games:data', (gamesData) => {
    config.load(gamesData);
});

/**
 * forms data from react.
 */

dispatcher.listen('forms:data', (formsData) => {
    config.load(formsData);
});

/**
 * Main render of the application.
 */
const render = () => {
    const selector = '#application';
    const container = document.querySelector(selector);

    bundle.renderApp({ container });

    /**
     * Support for react-snap, marking server-side pre-rendering
     */
    window.snapSaveState = () => container.setAttribute('data-server-rendered', 'true');
};

if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", render);
} else {
    render();
}
